import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  DataLabel,
  DataLabelValue,
  TextBoxInput,
} from 'src/Components/Common';
import { AddressLabelDisplayMapping } from 'src/Utility/sanitizers';
import { CancelIcon } from 'src/Components/Common/Svg';
import './FibreAddress.css';

const FibreAddressLineC = ({ label, onValueSave, value, ...props }) => {

  const [isEditMode, setEditMode] = useState(false);
  const [newValue, setNewValue] = useState('');


  return (
    <div className='fibre-address-line' { ...props }>
      <DataLabel dataLabel={AddressLabelDisplayMapping[label]} automationidattr={`FibreAddress${AddressLabelDisplayMapping[label]?.replace(/ /g, '')}`} />

      { !!value || (label !== 'unitNumber' && label !== 'buildingName')
          ? <DataLabelValue dataLabelValue={ value } automationidattr={ `FibreAddress${AddressLabelDisplayMapping[label]?.replace(/ /g, '')}` } />
          :
          (!value && !isEditMode)
            ? <label
              className='line-value-placeholder'
              onClick={ () => setEditMode(true) }
              automationid={ `SalesLead_Label_FibreAdress${label?.replace(/ /g, '')}Add_0` }
            >
              Add { AddressLabelDisplayMapping[label] }
            </label>
            : <div className='address-editor-container'>
              <TextBoxInput
                updateValue={ e => setNewValue(e.target.value) }
                value={newValue}
                automationidattr={ `FibreAdress${AddressLabelDisplayMapping[label]?.replace(/ /g, '')}` }
                config={ label == 'buildingName' ? {
                    maxLength: 30
                  }:
                  null
                }
              />
              <span
                className='address-line-action'
                onClick={() => {
                  onValueSave(newValue);
                  setEditMode(false);
                }}
                automationid={`SalesLead_Span_FibreAdress${label?.replace(/ /g, '')}Save_0`}
              >save</span>

              <span
                className='address-line-action'
                onClick={() => setEditMode(false)}
                automationid={`SalesLead_Span_FibreAdress${label?.replace(/ /g, '')}Cancel_0`}

              >
                <CancelIcon />
              </span>
            </div>
      }
    </div>
  );
};

FibreAddressLineC.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onValueSave: PropTypes.func,
}

export const FibreAddressLine = FibreAddressLineC;
